export default {
      id: "utiq-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#utiq",
      toString: function () {
        return this.url;
      }
    }